import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface IdleWarningDialogData {
  secondsRemaining$: Observable<number>;
}

@Component({
  selector: 'idle-warning-dialog',
  templateUrl: './idle-warning-dialog.component.html',
  styleUrl: './idle-warning-dialog.component.css',
  standalone: false
})
export class IdleWarningDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IdleWarningDialogComponent, 'stay' | 'logout'>,
    @Inject(MAT_DIALOG_DATA) public data: IdleWarningDialogData
  ) { }

  staySignedIn(): void {
    this.dialogRef.close('stay');
  }

  logoutNow(): void {
    this.dialogRef.close('logout');
  }
}
